import type { Category } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import { defineStore, acceptHMRUpdate } from "pinia";

interface State {
	categoryTree: CategoryTree;
	currentCategoryId: number | null;
}

type CategoryTree = { [key: string]: Category[] };
export const useCategoryStore = defineStore({
	id: "categoryStore",
	state: (): State => {
		return {
			categoryTree: {},
			currentCategoryId: null
		};
	},
	actions: {
		async setCategoryTree(value: CategoryTree) {
			this.categoryTree = value;
		},
		async setCategoryId(value: number) {
			this.currentCategoryId = value;
		}
	},
	getters: {
		getCategoryTree: (state) => state.categoryTree,
		getCategoryId: (state) => state.currentCategoryId
	},
	persist: [{ storage: persistedState.localStorage, paths: ["categoryTree"] }]
});
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCategoryStore, import.meta.hot));
}
